module.exports = __webpack_public_path__ + "static/img/badge_no.66b75aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video/badge_no.png
// module id = oKKT
// module chunks = 1